export const TABLE_ROW_LENGTH_OPTIONS = [10, 15, 25]
export const draggingOverStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
});